import type { ApiResponse } from "@/types/common";
import { apiClient, unwrapApiResponse } from "./httpClient";

export interface ChannelProductCreateDto {
  name: string;
  sku?: string;
  barcode?: string;
  categoryId?: number;
  description?: string;
  shortDescription?: string;
  mrp: number;
  distributorPrice: number;
  wholesalePrice: number;
  retailPrice: number;
  sellingPrice: number;
  deliveryCharge: number;
  gstPercent: number;
  distributorCommissionPercent: number;
  wholesaleCommissionPercent: number;
  retailCommissionPercent: number;
  businessVolume: number;
  unit: string;
  unitValue: number;
  isVeg: boolean;
  tags?: string;
  brand?: string;
  weight: number;
  publish: boolean;
  initialStock: number;
  images?: string[];
}

export interface ChannelProductUpdateDto {
  name: string;
  sku?: string;
  barcode?: string;
  categoryId?: number;
  description?: string;
  shortDescription?: string;
  mrp: number;
  distributorPrice: number;
  wholesalePrice: number;
  retailPrice: number;
  sellingPrice: number;
  deliveryCharge: number;
  gstPercent: number;
  distributorCommissionPercent: number;
  wholesaleCommissionPercent: number;
  retailCommissionPercent: number;
  businessVolume: number;
  unit: string;
  unitValue: number;
  isActive: boolean;
  isVeg: boolean;
  tags?: string;
  brand?: string;
  weight: number;
  images?: string[];
}

export interface ChannelProductDetail {
  id: number;
  name: string;
  slug: string;
  sku?: string;
  barcode?: string;
  categoryId?: number;
  categoryName?: string;
  description?: string;
  shortDescription?: string;
  adminId?: string;
  adminName?: string;
  mrp: number;
  distributorPrice: number;
  wholesalePrice: number;
  retailPrice: number;
  sellingPrice: number;
  deliveryCharge: number;
  gstPercent: number;
  distributorCommissionPercent: number;
  wholesaleCommissionPercent: number;
  retailCommissionPercent: number;
  businessVolume: number;
  unit: string;
  unitValue: number;
  isActive: boolean;
  isVeg: boolean;
  tags?: string;
  brand?: string;
  weight: number;
  adminStock: number;
  images: string[];
  createdAt: string;
}

export const channelProductsService = {
  create(dto: ChannelProductCreateDto): Promise<ChannelProductDetail> {
    return unwrapApiResponse(
      apiClient.post<ApiResponse<ChannelProductDetail>>("/ChannelProducts", dto),
    );
  },

  getById(id: number): Promise<ChannelProductDetail> {
    return unwrapApiResponse(
      apiClient.get<ApiResponse<ChannelProductDetail>>(`/ChannelProducts/${id}`),
    );
  },

  update(id: number, dto: ChannelProductUpdateDto): Promise<ChannelProductDetail> {
    return unwrapApiResponse(
      apiClient.put<ApiResponse<ChannelProductDetail>>(`/ChannelProducts/${id}`, dto),
    );
  },

  delete(id: number): Promise<boolean> {
    return unwrapApiResponse(
      apiClient.delete<ApiResponse<boolean>>(`/ChannelProducts/${id}`),
    );
  },

  cleanDuplicates(): Promise<boolean> {
    return unwrapApiResponse(
      apiClient.post<ApiResponse<boolean>>("/ChannelProducts/clean-duplicates"),
    );
  },
};
